<template>
  <div class="columns is-multiline">
    <div
      v-for="(currentGroup, checkIndex) in filterOptions.region"
      :key="'currentGroup' + checkIndex"
      class="control column"
      :class="{
        'is-3-desktop is-6-mobile': (currentGroup.subregion && currentGroup.subregion?.length > 2),
        'is-12-desktop': !(currentGroup.subregion && currentGroup.subregion?.length > 2)
      }"
    >
      <div>
        <checkbox-two-level
          :group-id="currentGroup.id + ''"
          :label="currentGroup.name"
          :data-list="currentGroup.subregion"
          :show-header="currentGroup.subregion && currentGroup.subregion?.length > 2"
          :default-show-list="false"
          :values="regions[currentGroup.id]"
          @update:check-result="toggleCurrent"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/*  */
import CheckboxTwoLevel from '@/components/checkbox/CheckboxTwoLevel.vue';
import { rawdataState } from '@/composables/state/rawdataApp';

const {
  // state,
  filterOptions,
  regions,
  resetDownloadState,
} = rawdataState();

const toggleCurrent = (selectedValues: string [], groupId: string) => {
  regions.value[groupId] = selectedValues;
  if (selectedValues.length > 0) {
    Object.keys(regions.value).forEach(key => {
      if (key + '' !== groupId) {
        regions.value[key] = [];
      }
    });
  }
  resetDownloadState();
};

// const emit = defineEmits(['update:modelValue']);

// // const toggleAll = () => {
// //   console.log(props.selectAll);
// //   emit('update:modelValue', !props.selectAll, true); // previously was `this.$emit('input', title)`
// //   // this.$emit('filter:modelValue', value) // previously was `this.$emit('input', title)`
// // };

// watch(() => props.selectAll, () => {
//   (props.dataList ?? []).forEach(x => {
//     x.checked = props.selectAll;
//   });
// });

// // /** set set update selectAll */

// // const completedInputModel = computed({
// //   // getter
// //   get () {
// //     return (props.selectAll || (props.dataList ?? []).find(x => x.checked) != null);
// //   },
// //   // setter
// //   set (newValue: boolean) {
// //     emit('update:modelValue', newValue);
// //   }
// // });
</script>
<style lang="scss" scoped>
.bold {
  font-weight: 700;
}
.list {
  margin-left: 1rem;
}
</style>
